import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export const getShiftWorkbenchTemplate = () => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `shift-workbench/workbench-template`
  );
};
export const AddShiftWorkbenchTemplate = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() +
      `shift-workbench/workbench-template/create`,
    obj,
    { headers }
  );
};

export const EditShiftWorkbenchTemplate = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() +
      `shift-workbench/workbench-template/edit`,
    obj,
    { headers }
  );
};

export const DeleteShiftWorkbenchTemplate = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() +
      `shift-workbench/workbench-template/delete`,
    obj,
    { headers }
  );
};
